export default {
  cad: {
    sectionTitle: 'CAD',
    previewMode: '預覽模式',
    surface: '表面',
    wireframe: '線框',
    wireframeUnavailable: '線框預覽尚未提供',
  },
  visualization: {
    sectionTitle: '視覺化',
    qualityMetric: '品質指標',
  },
  qualityMetric: {
    // 網格檢視器的品質度量下拉選單. 沿用 [本地化 + 英文原名] 的同列
    // 模式 (同 MeshGen 尺寸預設下拉選單), 使英文術語可於文獻搜尋直接
    // 對應. SICN / Gamma 為專有縮寫直接保留.
    sicn: 'SICN 形狀評分 (Ideal=1)',
    gamma: 'Gamma 形狀評分 (Ideal=1)',
    skewness: '偏斜度 Skewness',
    aspectRatio: '長寬比 Aspect ratio',
    minAngle: '最小角度 Minimum angle',
    nonOrthogonality: '非正交性 Non-orthogonality',
  },
  cellInfo: {
    // 點選網格單元後的詳細讀出. 元素類型名稱沿用品質度量的
    // [本地化 + 英文原名] 模式.
    element: '元素 #{{id}}',
    region: '區域 {{tag}}',
    type: {
      triangle: '三角形 Triangle',
      quadrangle: '四邊形 Quadrangle',
      tetrahedron: '四面體 Tetrahedron',
      hexahedron: '六面體 Hexahedron',
      prism: '稜柱 Prism',
      pyramid: '角錐 Pyramid',
      polyhedron: '多面體 Polyhedron',
    },
  },
  meshViewer: {
    view: '檢視',
    auto: '自動',
    autoWithSource: '自動（{{source}}）',
    diagnosisStl: 'Diagnosis STL',
    serverStl: '伺服器 STL',
    fluidDomain: '流體域',
    fineStl: '精細 STL',
    cadTessellation: 'CAD 三角網格',
    extractedCavity: '擷取的空腔',
    loadingExtractedCavity: '正在載入擷取的空腔…',
    faceLabel: '面 {{index}}',
    clickFaceToAddBl: '點選面以加入 BL',
    pickSurface: '選取表面：{{source}}',
    noFluidDomainFallback: '正在本體表面上選取，而非流體空腔。',
    rendererError: '算繪器錯誤',
    webgpuUnsupported: '此瀏覽器不支援 WebGPU。請改用最新版的 Chrome 或 Edge。',
    webgpuUnavailableTitle: '3D 檢視器需要 WebGPU',
    webgpuUnavailableBody:
      '瀏覽器無法啟動 GPU 工作階段，因此無法算繪 3D 檢視器。這是瀏覽器或 GPU 設定的問題，你的網格沒有問題。',
    webgpuStepGpuPage:
      '開啟 edge://gpu 或 chrome://gpu，確認 WebGPU 顯示為「Hardware accelerated」。',
    webgpuStepAccel:
      '在瀏覽器設定中開啟「在可用時使用圖形加速」，然後重新啟動瀏覽器。',
    webgpuStepDriver: '更新你的顯示卡驅動程式。',
    webgpuStepRemote:
      '正在使用遠端桌面或虛擬機器嗎？它們通常沒有 GPU，請改在本機執行。',
    webglUnavailableTitle: '3D 檢視需要 WebGL',
    webglUnavailableBody:
      '瀏覽器無法啟動 WebGL，因此無法算繪此 3D 檢視。這是瀏覽器或 GPU 設定的問題，你的結果沒有問題。',
    webglStepGpuPage:
      '開啟 edge://gpu 或 chrome://gpu，確認 WebGL 顯示為「Hardware accelerated」。',
    meshTooLargeTitle: '網格過大，無法算繪',
    meshTooLargeBody:
      '此網格的網格單元數過多，瀏覽器 3D 檢視器無法載入。網格已成功產生 — 請下載（OpenFOAM、Fluent 或 STL）後在外部工具中開啟。',
    meshUnreadableTitle: '無法讀取此網格',
    meshUnreadableBody:
      '網格已成功產生，但檢視器無法讀取。這是檢視器的錯誤，不是網格的問題。請下載後以其他工具開啟，並回報下方的錯誤行。',
    uploadPrompt: '上傳 CAD 模型以開始',
    loadingMesh: '正在載入網格',
    loadingDiagnosisPreview: '正在載入 Diagnosis 預覽',
    loadingPreview: '正在載入預覽',
    buildingCadPreview: '正在建立 CAD 預覽',
    previewUnavailableTitle: '無法顯示 3D 預覽',
    previewUnavailableHint: '您仍可產生網格，只有預覽會受到影響。',
    noDiagnosisStl: '此幾何沒有 Diagnosis STL。請在下方選擇其他檢視。',
    noServerPreview: '此幾何沒有伺服器預覽。請在下方選擇其他檢視。',
    noPreviewAvailable: '此檔案沒有可用的預覽。',
    previewProvenanceSimplify:
      '此版本是簡化候選，並非上傳的檔案 — 在核准前沒有 3D 預覽。',
    buildPreviewMeshing: '網格化中… · {{stage}}',
    buildPreviewStageBlockmesh: '網域格線',
    buildPreviewStageSnapped: '表面（邊界層之前）',
    buildPreviewBuilding: '建立中',
    buildPreviewTooltip:
      '網格建立過程中的即時預覽（並非最終結果）。「網域格線」是覆蓋網格區域的背景區塊；「表面」是在邊界層之前擷取的幾何表面。',
  },
  viewerOverlay: {
    bodySolid: '實體',
    bodyXray: '透視',
    bodyHidden: '隱藏',
    viewAlong: '沿 {{axis}} 軸檢視',
    toggleWireframe: '切換線框',
    modelSolid: '模型: 實體',
    modelXray: '模型: X 光',
    modelHidden: '模型: 隱藏',
    toggleClip: '切換裁剪',
    flipSide: '翻轉側面',
    flipNeedsClip: '啟用裁剪後可翻轉',
    sliceViewPlane: '以檢視平面切片',
    slicePosition: '切片位置',
    fitView: '適應視圖',
    clipCrinkleActive: '皺褶切割：保留完整網格單元。切換為乾淨的剖面平面。',
    clipSectionActive: '剖面切割：乾淨平面。切換回保留完整單元的皺褶切割。',
    crinkleCut: '皺褶',
    sectionCut: '剖面',
  },
  controlsHelp: {
    show: '檢視器操作',
    mouse: '滑鼠',
    keyboard: '鍵盤',
    dragL: '左鍵拖曳',
    dragR: '右鍵拖曳',
    shiftDragL: 'Shift + 左鍵拖曳',
    dragLR: '左 + 右鍵拖曳',
    wheel: '滾輪',
    click: '點擊',
    orbit: '環繞',
    pan: '平移',
    roll: '滾轉',
    zoom: '朝游標縮放',
    pick: '檢查單元',
    lookAxis: '沿 X / Y / Z 軸檢視',
    pitch: '俯仰 ±90°',
    yaw: '偏航 ±90°',
    rollKey: '滾轉 ±90°',
    slice: '以檢視平面切片',
    cycleBody: '循環 實體 / 透視 / 隱藏',
    wireframe: '切換線框',
    clip: '剖面切割開關',
    flip: '翻轉剖面側',
  },
  viewerLoading: {
    loadingMesh: '正在載入網格...',
    loadingPreview: '正在載入預覽...',
    parsingMesh: '正在解析網格...',
    downloadingMesh: '正在下載網格',
    cachingMesh: '正在快取網格...',
    restoringMemory: '正在還原記憶體...',
    loadingCached: '正在載入快取網格 {{received}} / {{total}} 位元組',
    downloading: '正在下載 {{received}} / {{total}} 位元組',
  },
  debugViewer: {
    loadModel: '載入模型',
    loading: '載入中…',
    meshFileLabel: '網格檔案',
    qualityFileLabel: '品質指標檔案',
  },
  // 公開 `/whats-new` 頁面的框架文字 — 頁面標題、區塊標籤、狀態徽章。
  // 每個版本的釋出說明條目維持英文原文, 以避免每次發布都要重譯三種
  // 語系（詳見 whats-new/AGENTS.md）.
  changelog: {
    backToApp: '返回應用程式',
    title: '更新紀錄與路線圖',
    subtitle: 'Khorium MeshGen 的發佈說明與後續規劃',
    roadmapHeader: '路線圖',
    releasedHeader: '已發佈',
    badgeLatest: '最新',
    badgeUpcoming: '即將推出',
    sectionLabelNew: '新增',
    sectionLabelImproved: '改善',
    sectionLabelFixed: '修正',
    datePlanned: '規劃中',
  },
} as const;
